import React, { forwardRef } from 'react';
import { cva } from 'class-variance-authority';

import { cn } from 'lib/utils';

const inputVariants = cva(
  'flex w-full rounded-md px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm placeholder:text-gray-500',
  {
    variants: {
      variant: {
        default: 'border border-input bg-background',
        hajj: 'bg-white/80 backdrop-blur-sm border focus:border-hajj-primary focus:ring-4 focus:ring-hajj-primary/10 transition-all duration-200 rounded-sm-xl',
        subtle: 'border-transparent bg-muted/10',
        disabled: 'bg-muted/50 text-muted-foreground cursor-not-allowed border-2',
      },
      size: {
        default: 'h-10',
        lg: 'h-14 text-lg',
        sm: 'h-10 text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

const Input = forwardRef(({ className, variant, size, type = 'text', ...props }, ref) => {
  return <input type={type} className={cn(inputVariants({ variant, size }), className)} ref={ref} {...props} />;
});
Input.displayName = 'Input';

export { Input, inputVariants };
